import { ExpandMore } from '@mui/icons-material';
import cn from 'classnames';

import s from './ExpandIcon.module.scss';

type Props = {
  isOpen: boolean;
  /** Свёрнутый смотрит вправо, как узел дерева; иначе вниз, как выпадающий раздел */
  isTree?: boolean;
};

/** Шеврон раскрытия: поворачивается, а не меняется на другую иконку */
const ExpandIcon: React.FC<Props> = ({ isOpen, isTree = false }) => (
  <ExpandMore
    fontSize="small"
    className={cn(s.icon, isTree && !isOpen && s.icon_tree, !isTree && isOpen && s.icon_open)}
  />
);

export { ExpandIcon };
